export default [
    {
        "error_id": "T-SCRL-01",
        "data": [
            {
                "cross_section": "64818",
                "channel": "645.00",
                "length": "756.18",
                "diff": "100.01",
                "coords": [
                    [
                        2524712.9990049414,
                        994425.3901859834
                    ],
                    [
                        2524682.94,
                        994471.84
                    ],
                    [
                        2524721.14,
                        994412.81
                    ],
                    [
                        2524728.08,
                        994402.4
                    ],
                    [
                        2524733.29,
                        994388.51
                    ],
                    [
                        2524738.5,
                        994374.62
                    ],
                    [
                        2524743.7,
                        994360.73
                    ],
                    [
                        2524750.65,
                        994332.95
                    ],
                    [
                        2524754.12,
                        994299.96
                    ],
                    [
                        2524757.59,
                        994277.4
                    ],
                    [
                        2524762.8,
                        994256.56
                    ],
                    [
                        2524768.01,
                        994232.26
                    ],
                    [
                        2524778.43,
                        994207.95
                    ],
                    [
                        2524785.37,
                        994187.12
                    ],
                    [
                        2524794.05,
                        994166.28
                    ],
                    [
                        2524799.26,
                        994129.83
                    ],
                    [
                        2524802.73,
                        994098.58
                    ],
                    [
                        2524827.04,
                        994055.17
                    ],
                    [
                        2524835.72,
                        994030.87
                    ],
                    [
                        2524842.66,
                        993994.41
                    ],
                    [
                        2524853.46,
                        993981.46
                    ],
                    [
                        2524868.7,
                        993963.16
                    ],
                    [
                        2524891.27,
                        993931.91
                    ],
                    [
                        2524906.9,
                        993904.13
                    ],
                    [
                        2524915.58,
                        993888.51
                    ],
                    [
                        2524945.8517417004,
                        993834.7722966092
                    ]
                ]
            },
            {
                "cross_section": "58870",
                "channel": "148.00",
                "length": "186.31",
                "diff": "100.01",
                "coords": [
                    [
                        2526494.9193457314,
                        990463.4966748928
                    ],
                    [
                        2526476.34,
                        990468.37
                    ],
                    [
                        2526582.25,
                        990440.59
                    ],
                    [
                        2526603.08,
                        990431.91
                    ],
                    [
                        2526633.4037505146,
                        990414.3531784769
                    ]
                ]
            },
            {
                "cross_section": "57987",
                "channel": "705.00",
                "length": "815.19",
                "diff": "100.01",
                "coords": [
                    [
                        2527001.096985638,
                        989871.0010017235
                    ],
                    [
                        2526948.57,
                        989888.51
                    ],
                    [
                        2527000.65,
                        989871.15
                    ],
                    [
                        2527028.43,
                        989867.67
                    ],
                    [
                        2527047.52,
                        989876.35
                    ],
                    [
                        2527064.89,
                        989881.56
                    ],
                    [
                        2527072.07,
                        989879.9
                    ],
                    [
                        2527087.45,
                        989876.35
                    ],
                    [
                        2527111.76,
                        989853.78
                    ],
                    [
                        2527125.65,
                        989834.69
                    ],
                    [
                        2527148.22,
                        989824.27
                    ],
                    [
                        2527176.73,
                        989799.48
                    ],
                    [
                        2527188.15,
                        989789.55
                    ],
                    [
                        2527198.57,
                        989787.81
                    ],
                    [
                        2527212.45,
                        989784.34
                    ],
                    [
                        2527226.34,
                        989777.4
                    ],
                    [
                        2527233.29,
                        989765.24
                    ],
                    [
                        2527243.7,
                        989753.09
                    ],
                    [
                        2527250.65,
                        989746.15
                    ],
                    [
                        2527254.12,
                        989735.73
                    ],
                    [
                        2527261.07,
                        989721.84
                    ],
                    [
                        2527262.8,
                        989711.42
                    ],
                    [
                        2527262.8,
                        989699.27
                    ],
                    [
                        2527262.8,
                        989692.33
                    ],
                    [
                        2527262.8,
                        989673.23
                    ],
                    [
                        2527261.07,
                        989655.87
                    ],
                    [
                        2527261.07,
                        989645.45
                    ],
                    [
                        2527261.07,
                        989633.3
                    ],
                    [
                        2527261.07,
                        989614.2
                    ],
                    [
                        2527261.07,
                        989591.63
                    ],
                    [
                        2527261.07,
                        989586.42
                    ],
                    [
                        2527262.8,
                        989577.74
                    ],
                    [
                        2527269.75,
                        989563.85
                    ],
                    [
                        2527272.43,
                        989561.17
                    ],
                    [
                        2527280.16,
                        989553.44
                    ],
                    [
                        2527288.84,
                        989544.76
                    ],
                    [
                        2527316.62,
                        989523.92
                    ],
                    [
                        2527330.51,
                        989516.98
                    ],
                    [
                        2527340.93,
                        989506.56
                    ],
                    [
                        2527353.08,
                        989494.41
                    ],
                    [
                        2527366.97,
                        989478.78
                    ],
                    [
                        2527375.65,
                        989464.9
                    ],
                    [
                        2527382.59,
                        989454.48
                    ],
                    [
                        2527394.75,
                        989440.59
                    ],
                    [
                        2527403.43,
                        989431.91
                    ],
                    [
                        2527413.84,
                        989418.02
                    ],
                    [
                        2527416.719828854,
                        989412.4459018811
                    ]
                ]
            },
            {
                "cross_section": "53580",
                "channel": "1741.00",
                "length": "1933.59",
                "diff": "100.01",
                "coords": [
                    [
                        2528280.1533064586,
                        987195.4321991688
                    ],
                    [
                        2528228.08,
                        987114.2
                    ],
                    [
                        2528314.89,
                        987249.62
                    ],
                    [
                        2528329.15,
                        987269.83
                    ],
                    [
                        2528335.72,
                        987279.13
                    ],
                    [
                        2528363.5,
                        987332.95
                    ],
                    [
                        2528368.7,
                        987360.73
                    ],
                    [
                        2528363.5,
                        987374.62
                    ],
                    [
                        2528358.29,
                        987390.24
                    ],
                    [
                        2528333.98,
                        987418.02
                    ],
                    [
                        2528323.57,
                        987437.12
                    ],
                    [
                        2528314.89,
                        987459.69
                    ],
                    [
                        2528302.73,
                        987477.05
                    ],
                    [
                        2528294.05,
                        987490.94
                    ],
                    [
                        2528287.11,
                        987515.24
                    ],
                    [
                        2528276.69,
                        987537.81
                    ],
                    [
                        2528269.75,
                        987567.33
                    ],
                    [
                        2528268.01,
                        987605.52
                    ],
                    [
                        2528268.01,
                        987647.19
                    ],
                    [
                        2528268.01,
                        987671.49
                    ],
                    [
                        2528276.53,
                        987686.09
                    ],
                    [
                        2528280.16,
                        987692.33
                    ],
                    [
                        2528307.94,
                        987725.31
                    ],
                    [
                        2528321.83,
                        987742.67
                    ],
                    [
                        2528363.5,
                        987765.24
                    ],
                    [
                        2528372.48,
                        987768.7
                    ],
                    [
                        2528386.07,
                        987773.92
                    ],
                    [
                        2528430.41,
                        987794.93
                    ],
                    [
                        2528452.04,
                        987805.17
                    ],
                    [
                        2528498.91,
                        987815.59
                    ],
                    [
                        2528512.8,
                        987815.59
                    ],
                    [
                        2528531.9,
                        987815.59
                    ],
                    [
                        2528559.68,
                        987817.33
                    ],
                    [
                        2528577.04,
                        987827.74
                    ],
                    [
                        2528613.5,
                        987848.58
                    ],
                    [
                        2528623.91,
                        987858.99
                    ],
                    [
                        2528639.54,
                        987864.2
                    ],
                    [
                        2528662.11,
                        987874.62
                    ],
                    [
                        2528689.89,
                        987888.51
                    ],
                    [
                        2528705.51,
                        987905.87
                    ],
                    [
                        2528719.4,
                        987930.17
                    ],
                    [
                        2528724.61,
                        987938.85
                    ],
                    [
                        2528754.12,
                        987968.37
                    ],
                    [
                        2528771.48,
                        987983.99
                    ],
                    [
                        2528820.09,
                        988039.55
                    ],
                    [
                        2528827.04,
                        988048.23
                    ],
                    [
                        2528846.14,
                        988063.85
                    ],
                    [
                        2528868.7,
                        988082.95
                    ],
                    [
                        2528903.43,
                        988107.26
                    ],
                    [
                        2528926,
                        988115.94
                    ],
                    [
                        2528936.41,
                        988124.62
                    ],
                    [
                        2528955.51,
                        988128.09
                    ],
                    [
                        2528981.45,
                        988125.1
                    ],
                    [
                        2528987.22,
                        988124.43
                    ],
                    [
                        2529000.65,
                        988122.88
                    ],
                    [
                        2529019.75,
                        988115.94
                    ],
                    [
                        2529030.16,
                        988108.99
                    ],
                    [
                        2529045.79,
                        988100.31
                    ],
                    [
                        2529057.94,
                        988088.16
                    ],
                    [
                        2529066.62,
                        988070.8
                    ],
                    [
                        2529073.57,
                        988053.44
                    ],
                    [
                        2529077.04,
                        988032.6
                    ],
                    [
                        2529077.21,
                        988031.66
                    ],
                    [
                        2529080.51,
                        988013.51
                    ],
                    [
                        2529089.19,
                        987987.46
                    ],
                    [
                        2529101.34,
                        987973.58
                    ],
                    [
                        2529110.02,
                        987964.9
                    ],
                    [
                        2529120.44,
                        987954.48
                    ],
                    [
                        2529128.73,
                        987948.45
                    ],
                    [
                        2529139.54,
                        987940.59
                    ],
                    [
                        2529160.37,
                        987923.23
                    ],
                    [
                        2529192.927116963,
                        987897.0529516201
                    ]
                ]
            },
            {
                "cross_section": "45484",
                "channel": "139.00",
                "length": "238.90",
                "diff": "100.01",
                "coords": [
                    [
                        2534506.0813567787,
                        987839.3404254656
                    ],
                    [
                        2534457.25,
                        987829.48
                    ],
                    [
                        2534628.4,
                        987864.04
                    ],
                    [
                        2534642.809279718,
                        987865.4836575454
                    ]
                ]
            },
            {
                "cross_section": "36846",
                "channel": "601.00",
                "length": "718.18",
                "diff": "100.01",
                "coords": [
                    [
                        2539467.226088263,
                        990704.3793379097
                    ],
                    [
                        2539452.04,
                        990647.41
                    ],
                    [
                        2539467.93,
                        990707.02
                    ],
                    [
                        2539468.89,
                        990710.6
                    ],
                    [
                        2539471.34,
                        990712.81
                    ],
                    [
                        2539514.22,
                        990751.4
                    ],
                    [
                        2539559.55,
                        990769.54
                    ],
                    [
                        2539564.41,
                        990771.48
                    ],
                    [
                        2539627.55,
                        990796.73
                    ],
                    [
                        2539700.08,
                        990810.33
                    ],
                    [
                        2539754.48,
                        990814.87
                    ],
                    [
                        2539804.34,
                        990814.87
                    ],
                    [
                        2539867.81,
                        990787.67
                    ],
                    [
                        2539917.67,
                        990746.87
                    ],
                    [
                        2539940.28,
                        990708.11
                    ],
                    [
                        2539949.41,
                        990692.47
                    ],
                    [
                        2539952.9201046308,
                        990656.5733988498
                    ]
                ]
            },
            {
                "cross_section": "32012",
                "channel": "868.00",
                "length": "1009.26",
                "diff": "100.01",
                "coords": [
                    [
                        2542194.2724492494,
                        990290.9153823806
                    ],
                    [
                        2542179.47,
                        990221.84
                    ],
                    [
                        2542215.93,
                        990391.98
                    ],
                    [
                        2542226.34,
                        990433.65
                    ],
                    [
                        2542236.76,
                        990454.48
                    ],
                    [
                        2542247.18,
                        990478.78
                    ],
                    [
                        2542251.11,
                        990488.61
                    ],
                    [
                        2542257.59,
                        990504.83
                    ],
                    [
                        2542264.54,
                        990522.19
                    ],
                    [
                        2542273.35,
                        990536.51
                    ],
                    [
                        2542278.43,
                        990544.76
                    ],
                    [
                        2542292.05,
                        990574.16
                    ],
                    [
                        2542311.41,
                        990615.94
                    ],
                    [
                        2542314.89,
                        990638.51
                    ],
                    [
                        2542321.83,
                        990657.6
                    ],
                    [
                        2542328.77,
                        990680.17
                    ],
                    [
                        2542339.19,
                        990699.27
                    ],
                    [
                        2542347.87,
                        990713.16
                    ],
                    [
                        2542360.02,
                        990730.52
                    ],
                    [
                        2542372.18,
                        990749.62
                    ],
                    [
                        2542391.27,
                        990766.98
                    ],
                    [
                        2542420.79,
                        990796.49
                    ],
                    [
                        2542435.01,
                        990809.92
                    ],
                    [
                        2542452.04,
                        990826.01
                    ],
                    [
                        2542476.34,
                        990890.24
                    ],
                    [
                        2542479.82,
                        990921.49
                    ],
                    [
                        2542481.55,
                        990971.84
                    ],
                    [
                        2542479.82,
                        991001.35
                    ],
                    [
                        2542473.64,
                        991028.52
                    ],
                    [
                        2542475.2564203865,
                        991081.5393618214
                    ]
                ]
            },
            {
                "cross_section": "26436",
                "channel": "715.00",
                "length": "830.72",
                "diff": "100.01",
                "coords": [
                    [
                        2544673.3536889437,
                        993674.1121007015
                    ],
                    [
                        2544618.7,
                        993692.33
                    ],
                    [
                        2544702.04,
                        993664.55
                    ],
                    [
                        2544724.61,
                        993661.08
                    ],
                    [
                        2544755.86,
                        993662.81
                    ],
                    [
                        2544765.23,
                        993664.25
                    ],
                    [
                        2544778.43,
                        993666.28
                    ],
                    [
                        2544799.26,
                        993664.55
                    ],
                    [
                        2544821.83,
                        993662.81
                    ],
                    [
                        2544847.87,
                        993661.08
                    ],
                    [
                        2544870.44,
                        993657.6
                    ],
                    [
                        2544891.27,
                        993657.6
                    ],
                    [
                        2544910.37,
                        993655.87
                    ],
                    [
                        2544929.47,
                        993650.66
                    ],
                    [
                        2544945.09,
                        993648.92
                    ],
                    [
                        2544962.45,
                        993645.45
                    ],
                    [
                        2544985.74,
                        993639.63
                    ],
                    [
                        2544988.51,
                        993638.94
                    ],
                    [
                        2544990.23,
                        993638.51
                    ],
                    [
                        2545004.12,
                        993628.09
                    ],
                    [
                        2545018.01,
                        993619.41
                    ],
                    [
                        2545037.11,
                        993610.73
                    ],
                    [
                        2545057.94,
                        993608.99
                    ],
                    [
                        2545080.51,
                        993612.46
                    ],
                    [
                        2545108.29,
                        993624.62
                    ],
                    [
                        2545129.12,
                        993641.98
                    ],
                    [
                        2545149.95,
                        993654.13
                    ],
                    [
                        2545165.58,
                        993654.13
                    ],
                    [
                        2545182.94,
                        993650.66
                    ],
                    [
                        2545203.77,
                        993638.51
                    ],
                    [
                        2545219.4,
                        993626.35
                    ],
                    [
                        2545235.02,
                        993617.67
                    ],
                    [
                        2545255.86,
                        993607.26
                    ],
                    [
                        2545276.69,
                        993603.78
                    ],
                    [
                        2545314.89,
                        993605.52
                    ],
                    [
                        2545349.586450416,
                        993615.7514965355
                    ]
                ]
            },
            {
                "cross_section": "24950",
                "channel": "395.00",
                "length": "455.60",
                "diff": "100.01",
                "coords": [
                    [
                        2545831.6277658152,
                        994137.7841444496
                    ],
                    [
                        2545811.41,
                        994114.2
                    ],
                    [
                        2545832.25,
                        994138.51
                    ],
                    [
                        2545839.67,
                        994148.4
                    ],
                    [
                        2545847.87,
                        994159.34
                    ],
                    [
                        2545861.76,
                        994197.53
                    ],
                    [
                        2545887.8,
                        994237.46
                    ],
                    [
                        2545920.79,
                        994270.45
                    ],
                    [
                        2545967.66,
                        994284.34
                    ],
                    [
                        2545987.3,
                        994296.29
                    ],
                    [
                        2546009.77,
                        994301.91
                    ],
                    [
                        2546030.83,
                        994306.12
                    ],
                    [
                        2546047.68,
                        994312.44
                    ],
                    [
                        2546072.96,
                        994325.08
                    ],
                    [
                        2546087.71,
                        994333.51
                    ],
                    [
                        2546097.11,
                        994339.15
                    ],
                    [
                        2546098.24,
                        994339.82
                    ],
                    [
                        2546105.13,
                        994342.12
                    ],
                    [
                        2546110.88,
                        994344.04
                    ],
                    [
                        2546134.925404646,
                        994354.3135112762
                    ]
                ]
            },
            {
                "cross_section": "24461",
                "channel": "654.00",
                "length": "852.87",
                "diff": "100.01",
                "coords": [
                    [
                        2546191.8936939025,
                        994429.7553883899
                    ],
                    [
                        2546131.94,
                        994350.36
                    ],
                    [
                        2546202.62,
                        994443.96
                    ],
                    [
                        2546209.88,
                        994453.57
                    ],
                    [
                        2546216.29,
                        994464.26
                    ],
                    [
                        2546235.16,
                        994495.7
                    ],
                    [
                        2546235.16,
                        994504.13
                    ],
                    [
                        2546237.27,
                        994518.88
                    ],
                    [
                        2546243.59,
                        994535.73
                    ],
                    [
                        2546243.59,
                        994544.15
                    ],
                    [
                        2546256.23,
                        994579.96
                    ],
                    [
                        2546258.33,
                        994594.71
                    ],
                    [
                        2546258.33,
                        994617.88
                    ],
                    [
                        2546258.33,
                        994645.26
                    ],
                    [
                        2546258.33,
                        994666.33
                    ],
                    [
                        2546258.33,
                        994683.18
                    ],
                    [
                        2546254.12,
                        994704.25
                    ],
                    [
                        2546247.8,
                        994729.52
                    ],
                    [
                        2546243.59,
                        994750.59
                    ],
                    [
                        2546238.5,
                        994762.46
                    ],
                    [
                        2546237.27,
                        994765.33
                    ],
                    [
                        2546220.42,
                        994803.25
                    ],
                    [
                        2546216.2,
                        994815.89
                    ],
                    [
                        2546210,
                        994836.97
                    ],
                    [
                        2546208.98,
                        994840.44
                    ],
                    [
                        2546205.67,
                        994851.7
                    ],
                    [
                        2546203.56,
                        994872.76
                    ],
                    [
                        2546199.35,
                        994965.45
                    ],
                    [
                        2546200.03,
                        994972.61
                    ],
                    [
                        2546196.83,
                        995006.56
                    ],
                    [
                        2546202.04,
                        995032.6
                    ],
                    [
                        2546215.4248067583,
                        995053.4996832561
                    ]
                ]
            },
            {
                "cross_section": "19557",
                "channel": "633.00",
                "length": "718.71",
                "diff": "100.01",
                "coords": [
                    [
                        2547354.930674067,
                        998723.7983710116
                    ],
                    [
                        2547320.25,
                        998698.56
                    ],
                    [
                        2547373.25,
                        998737.13
                    ],
                    [
                        2547399.75,
                        998778.09
                    ],
                    [
                        2547416.9,
                        998824.52
                    ],
                    [
                        2547440.07,
                        998870.87
                    ],
                    [
                        2547452.71,
                        998915.1
                    ],
                    [
                        2547493.75,
                        998949.19
                    ],
                    [
                        2547500,
                        998958.54
                    ],
                    [
                        2547522.75,
                        998992.56
                    ],
                    [
                        2547524.5,
                        998998.31
                    ],
                    [
                        2547524.98,
                        999000
                    ],
                    [
                        2547542,
                        999060.06
                    ],
                    [
                        2547558.25,
                        999076.31
                    ],
                    [
                        2547570.75,
                        999088.94
                    ],
                    [
                        2547628.75,
                        999093.75
                    ],
                    [
                        2547667.25,
                        999093.75
                    ],
                    [
                        2547715.5,
                        999088.94
                    ],
                    [
                        2547767.747908457,
                        999083.7175254916
                    ]
                ]
            },
            {
                "cross_section": "16737",
                "channel": "582.00",
                "length": "667.67",
                "diff": "100.01",
                "coords": [
                    [
                        2549629.5613823286,
                        999308.5492814672
                    ],
                    [
                        2549594.53,
                        999332.63
                    ],
                    [
                        2549659.63,
                        999287.88
                    ],
                    [
                        2549720.65,
                        999247.19
                    ],
                    [
                        2549793.89,
                        999210.57
                    ],
                    [
                        2549802.91,
                        999208.32
                    ],
                    [
                        2549865.94,
                        999172.87
                    ],
                    [
                        2549978.62,
                        999133.43
                    ],
                    [
                        2550063.14,
                        999105.25
                    ],
                    [
                        2550157.1732761282,
                        999068.8232762322
                    ]
                ]
            },
            {
                "cross_section": "15312",
                "channel": "489.00",
                "length": "540.33",
                "diff": "100.01",
                "coords": [
                    [
                        2550831.413618595,
                        998621.1146902002
                    ],
                    [
                        2550818.14,
                        998643.24
                    ],
                    [
                        2550851.94,
                        998586.9
                    ],
                    [
                        2550880.11,
                        998502.38
                    ],
                    [
                        2550891.38,
                        998400.96
                    ],
                    [
                        2550908.28,
                        998327.72
                    ],
                    [
                        2550925.19,
                        998265.74
                    ],
                    [
                        2550934.51,
                        998209.78
                    ],
                    [
                        2550950.1366461315,
                        998150.2465630422
                    ]
                ]
            },
            {
                "cross_section": "14823",
                "channel": "618.00",
                "length": "717.96",
                "diff": "100.01",
                "coords": [
                    [
                        2550950.1366461315,
                        998150.2465630422
                    ],
                    [
                        2550936.46,
                        998198.13
                    ],
                    [
                        2550958.99,
                        998119.25
                    ],
                    [
                        2550992.8,
                        998062.91
                    ],
                    [
                        2551015.34,
                        998012.2
                    ],
                    [
                        2551037.87,
                        997955.85
                    ],
                    [
                        2551144.93,
                        997848.8
                    ],
                    [
                        2551190,
                        997826.26
                    ],
                    [
                        2551246.34,
                        997781.19
                    ],
                    [
                        2551317.2033651243,
                        997671.84145937
                    ]
                ]
            },
            {
                "cross_section": "14205",
                "channel": "882.00",
                "length": "970.39",
                "diff": "100.01",
                "coords": [
                    [
                        2551317.2033651243,
                        997671.84145937
                    ],
                    [
                        2551291.42,
                        997707.94
                    ],
                    [
                        2551319.59,
                        997668.5
                    ],
                    [
                        2551364.66,
                        997634.7
                    ],
                    [
                        2551426.64,
                        997606.53
                    ],
                    [
                        2551465.75,
                        997592.3
                    ],
                    [
                        2551488.62,
                        997583.99
                    ],
                    [
                        2551550.6,
                        997555.82
                    ],
                    [
                        2551618.21,
                        997527.65
                    ],
                    [
                        2551674.55,
                        997493.84
                    ],
                    [
                        2551736.53,
                        997437.5
                    ],
                    [
                        2551792.87,
                        997398.06
                    ],
                    [
                        2551837.95,
                        997358.62
                    ],
                    [
                        2551857.04,
                        997341.26
                    ],
                    [
                        2551899.92,
                        997302.27
                    ],
                    [
                        2551978.8,
                        997251.56
                    ],
                    [
                        2552058.858651803,
                        997210.01102484
                    ]
                ]
            },
            {
                "cross_section": "10491",
                "channel": "430.00",
                "length": "573.34",
                "diff": "100.01",
                "coords": [
                    [
                        2554210.629607578,
                        996884.1324364229
                    ],
                    [
                        2554142.13,
                        996862.73
                    ],
                    [
                        2554223.36,
                        996888.11
                    ],
                    [
                        2554256.37,
                        996893.19
                    ],
                    [
                        2554312.21,
                        996908.42
                    ],
                    [
                        2554370.6,
                        996928.73
                    ],
                    [
                        2554423.91,
                        996954.12
                    ],
                    [
                        2554459.45,
                        996971.89
                    ],
                    [
                        2554482.3,
                        996992.19
                    ],
                    [
                        2554530.53,
                        997027.73
                    ],
                    [
                        2554582.478733446,
                        997080.5964327919
                    ]
                ]
            },
            {
                "cross_section": "9361",
                "channel": "153.00",
                "length": "193.66",
                "diff": "100.01",
                "coords": [
                    [
                        2554827.8745597876,
                        997709.012672427
                    ],
                    [
                        2554819.39,
                        997690.83
                    ],
                    [
                        2554827.78,
                        997708.81
                    ],
                    [
                        2554914.173987166,
                        997835.9930227239
                    ]
                ]
            },
            {
                "cross_section": "9208",
                "channel": "525.00",
                "length": "805.77",
                "diff": "100.01",
                "coords": [
                    [
                        2554914.173987166,
                        997835.9930227239
                    ],
                    [
                        2554833.78,
                        997720.81
                    ],
                    [
                        2554914.13,
                        997835.93
                    ],
                    [
                        2554946.51,
                        997850.33
                    ],
                    [
                        2554964.5,
                        997853.92
                    ],
                    [
                        2554989.68,
                        997852.72
                    ],
                    [
                        2555005.27,
                        997850.33
                    ],
                    [
                        2555036.45,
                        997844.33
                    ],
                    [
                        2555062.84,
                        997838.33
                    ],
                    [
                        2555090.42,
                        997832.34
                    ],
                    [
                        2555113.21,
                        997819.15
                    ],
                    [
                        2555134.79,
                        997803.55
                    ],
                    [
                        2555157.58,
                        997787.96
                    ],
                    [
                        2555177.97,
                        997772.37
                    ],
                    [
                        2555195.95,
                        997759.18
                    ],
                    [
                        2555211.54,
                        997748.39
                    ],
                    [
                        2555229.53,
                        997742.39
                    ],
                    [
                        2555251.12,
                        997738.8
                    ],
                    [
                        2555273.91,
                        997736.4
                    ],
                    [
                        2555294.29,
                        997731.6
                    ],
                    [
                        2555317.08,
                        997726.8
                    ],
                    [
                        2555348.26,
                        997716.01
                    ],
                    [
                        2555367.45,
                        997712.41
                    ],
                    [
                        2555399.6864525103,
                        997698.5092074964
                    ]
                ]
            },
            {
                "cross_section": "6499",
                "channel": "500.00",
                "length": "557.71",
                "diff": "100.01",
                "coords": [
                    [
                        2557142.8925123913,
                        997946.989455062
                    ],
                    [
                        2557118.24,
                        997932.42
                    ],
                    [
                        2557156.43,
                        997954.99
                    ],
                    [
                        2557179,
                        997968.88
                    ],
                    [
                        2557257.13,
                        997981.03
                    ],
                    [
                        2557285.4,
                        997981.03
                    ],
                    [
                        2557302.26,
                        997981.03
                    ],
                    [
                        2557340.46,
                        997981.03
                    ],
                    [
                        2557368.24,
                        997981.03
                    ],
                    [
                        2557401.22,
                        997974.08
                    ],
                    [
                        2557402.17,
                        997973.75
                    ],
                    [
                        2557409.35,
                        997971.22
                    ],
                    [
                        2557430.74,
                        997963.67
                    ],
                    [
                        2557451.57,
                        997958.46
                    ],
                    [
                        2557474.22,
                        997956.65
                    ],
                    [
                        2557494.97,
                        997954.99
                    ],
                    [
                        2557536.64,
                        997954.99
                    ],
                    [
                        2557573.1,
                        997956.72
                    ],
                    [
                        2557602.61,
                        997961.93
                    ],
                    [
                        2557631.912101832,
                        997967.7517997052
                    ]
                ]
            }
        ]
    }
]